var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("el-col", { attrs: { span: 6 } }, [
            _c(
              "div",
              { staticClass: "grid-content", on: { click: _vm.toggleTab } },
              [
                _c(
                  "div",
                  { staticClass: "card-content" },
                  [
                    _c(
                      "el-card",
                      { attrs: { shadow: "never", bordered: false } },
                      [
                        _c("div", { staticClass: "header_title" }, [
                          _vm._v("监测商品总数(今日)"),
                        ]),
                      ]
                    ),
                    _c("div", { staticClass: "card-content-text" }, [
                      _vm._v(
                        _vm._s(_vm.dashboardStatisticsdata.totalProductCount)
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        class:
                          "card-content-text-small " +
                          (_vm.dashboardStatisticsdata.priceUpCount > 0
                            ? "text-red"
                            : "text-green"),
                      },
                      [
                        _c("i", { staticClass: "el-icon-top" }),
                        _vm._v(
                          _vm._s(_vm.dashboardStatisticsdata.priceUpCount) +
                            "件 (今日新增) "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "icon-content monitoring-icon1" }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/monitoring-icon1.png"),
                      alt: "",
                    },
                  }),
                ]),
              ]
            ),
          ]),
          _c("el-col", { attrs: { span: 6 } }, [
            _c(
              "div",
              { staticClass: "grid-content", on: { click: _vm.toggleTab } },
              [
                _c(
                  "div",
                  { staticClass: "card-content" },
                  [
                    _c(
                      "el-card",
                      { attrs: { shadow: "never", bordered: false } },
                      [
                        _c("div", { staticClass: "header_title" }, [
                          _vm._v("价格上涨商品 (今日)"),
                        ]),
                      ]
                    ),
                    _c("div", { staticClass: "card-content-text" }, [
                      _vm._v(_vm._s(_vm.dashboardStatisticsdata.priceUpCount)),
                    ]),
                    _c(
                      "div",
                      {
                        class:
                          "card-content-text-small " +
                          (_vm.dashboardStatisticsdata.yesterdayPriceUpCount > 0
                            ? "text-red"
                            : "text-green"),
                      },
                      [
                        _c("i", { staticClass: "el-icon-top" }),
                        _vm._v(
                          _vm._s(
                            _vm.dashboardStatisticsdata.yesterdayPriceUpCount
                          ) + "件 (较昨日) "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "icon-content monitoring-icon2" }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/monitoring-icon2.png"),
                      alt: "",
                    },
                  }),
                ]),
              ]
            ),
          ]),
          _c("el-col", { attrs: { span: 6 } }, [
            _c(
              "div",
              { staticClass: "grid-content", on: { click: _vm.toggleTab } },
              [
                _c(
                  "div",
                  { staticClass: "card-content" },
                  [
                    _c(
                      "el-card",
                      { attrs: { shadow: "never", bordered: false } },
                      [
                        _c("div", { staticClass: "header_title" }, [
                          _vm._v("价格下跌商品(今日)"),
                        ]),
                      ]
                    ),
                    _c("div", { staticClass: "card-content-text" }, [
                      _vm._v(
                        _vm._s(_vm.dashboardStatisticsdata.priceDownCount)
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        class:
                          "card-content-text-small " +
                          (_vm.dashboardStatisticsdata.yesterdayPriceDownCount >
                          0
                            ? "text-red"
                            : "text-green"),
                      },
                      [
                        _c("i", { staticClass: "el-icon-top" }),
                        _vm._v(
                          _vm._s(
                            _vm.dashboardStatisticsdata.yesterdayPriceDownCount
                          ) + "件 (较昨日) "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "icon-content monitoring-icon3" }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/monitoring-icon3.png"),
                      alt: "",
                    },
                  }),
                ]),
              ]
            ),
          ]),
          _c("el-col", { attrs: { span: 6 } }, [
            _c(
              "div",
              { staticClass: "grid-content", on: { click: _vm.toggleTab } },
              [
                _c(
                  "div",
                  { staticClass: "card-content" },
                  [
                    _c(
                      "el-card",
                      { attrs: { shadow: "never", bordered: false } },
                      [
                        _c("div", { staticClass: "header_title" }, [
                          _vm._v("价格预警商品"),
                        ]),
                      ]
                    ),
                    _c("div", { staticClass: "card-content-text" }, [
                      _vm._v(
                        _vm._s(
                          _vm.dashboardStatisticsdata.currentWarnCount || 0
                        )
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        class:
                          "card-content-text-small " +
                          (_vm.dashboardStatisticsdata.currentWarnCount > 0
                            ? "text-yellow"
                            : ""),
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.dashboardStatisticsdata.currentWarnCount > 0
                                ? "需要处理"
                                : "-"
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "icon-content monitoring-icon4" }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/monitoring-icon4.png"),
                      alt: "",
                    },
                  }),
                ]),
              ]
            ),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "lineStatic" },
        [
          _c(
            "div",
            { staticClass: "line-title" },
            [
              _c("span", [_vm._v("调价商品趋势")]),
              _c(
                "el-radio-group",
                {
                  on: { change: _vm.priceTrend },
                  model: {
                    value: _vm.radio,
                    callback: function ($$v) {
                      _vm.radio = $$v
                    },
                    expression: "radio",
                  },
                },
                [
                  _c("el-radio-button", { attrs: { label: "week" } }, [
                    _vm._v("周"),
                  ]),
                  _c("el-radio-button", { attrs: { label: "month" } }, [
                    _vm._v("月"),
                  ]),
                  _c("el-radio-button", { attrs: { label: "year" } }, [
                    _vm._v(" 年"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm.optionData
            ? _c("echarts-new", {
                key: _vm.keyNum,
                attrs: {
                  "option-data": _vm.optionData,
                  styles: _vm.style,
                  height: "100%",
                  width: "100%",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }